export const DEFAULT_MODEL_NAME = 'default';
